/* eslint-disable*/
import Vue from "vue";
import VueRouter from "vue-router";
import dashboard from "./routes/dashboard";
import authentication from "./routes/authentication";
import facility from "./routes/facility";
import requests from "./routes/requests";
import departments from "./routes/departments";
import certificate from "./routes/certificate";
import MainCertificate from "./routes/mainCertificate";
import Components from "./routes/components";
import Section from "./routes/sections";
import Requirements from "./routes/requirements";
import Offer from "./routes/offer";
import UserSite from "./routes/userSite";
import EngineersSetup from "./routes/engineers-setup";
import office from "./routes/office";
import delegator from "./routes/delegator";
import importer from "./routes/importer";
import requestsOver from "./routes/requestsOver";
import auditAssigned from "./routes/audit-assigned";
import allService from "./routes/all-service";
import serviceNeedApproval from "./routes/service-need-approval";
import serviceNeedSetMoney from "./routes/service-need-set-money";
import employess from "./routes/employess";
import devices from "./routes/devices";
import schedule from "./routes/schedule";
import setOffice from "./routes/set-office";
import report from "./routes/report";
import analysis from "./routes/analysis";
import sourceAccount from "./routes/source-account";
import accounting from "./routes/accounting";
import ParkEntries from "./routes/park-entries";
import PostEntries from "./routes/post-entries";
import product from "./routes/product";
import training from "./routes/training";
import post from "./routes/post";
import support from "./routes/support";
import lateReasons from "./routes/late-reasons";
import AutoGeneratReport from "./routes/auto-generate-report";
import PerformanceEvaluation from "./routes/performance-evaluation";
import personnelEvaluation from "./routes/personnel-evaluation";
import RequestInspection from "./routes/request-inspection";
import bankAccounts from "./routes/bank-accounts";
import productCertificate from "./routes/product-certificate";
import government from "./routes/government";
import { decrypted } from "@/store/auth/encryptData";
import unassignedRequest from "./routes/unassigned-request";
import sessionsTraining from "./routes/sessions-training";
import GroupCer from "./routes/group-cer";
import ManufactureWhite from "./routes/manufacture-white";
import Complaint from "./routes/complaint";
import NewTaskManagments from "./routes/new-task-managments";
import TypeCer from "./routes/type-cer";
import ZohoReports from "./routes/zoho-reports";
import Reimbursement from "./routes/reimbursement";
import Loan from "./routes/loan";
import Payroll from "./routes/payroll";
import InternalAudit from "./routes/internal-audit";
import HSCode from "./routes/hs-code";
import SFDASources from "./routes/sfda-sources";
import fasahCertificate from "./routes/fasah-certificate";
import documentaryRequirementsHalal from "./routes/documentary-requirements-halal";
import operationEngineersHalal from "./routes/operation-engineers-halal";
import headOfOperations from "./routes/head-of-operations";
import templatesHalal from "./routes/templates-halal";
import otherFormsHalal from "./routes/other-forms-halal";
import checkListHalal from "./routes/check-list-halal";
import decisionCommitteeHalal from "./routes/decision-committee-halal";
import permission from "./routes/permission";
import activeSessions from "./routes/active-sessions";
import salary from "./routes/salary";
import listRequiredDocuments from "./routes/list-required-documents";
import crmSystem from "./routes/crm-system";
import sfdaLabs from "./routes/sfda-labs";
import iso from "./routes/iso";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: "/", redirect: { name: "login" } },
    ...accounting,
    ...authentication,
    ...dashboard,
    ...facility,
    ...requests,
    ...departments,
    ...certificate,
    ...MainCertificate,
    ...Components,
    ...Section,
    ...Requirements,
    ...Offer,
    ...office,
    ...UserSite,
    ...delegator,
    ...importer,
    ...EngineersSetup,
    ...requestsOver,
    ...auditAssigned,
    ...allService,
    ...serviceNeedApproval,
    ...serviceNeedSetMoney,
    ...employess,
    ...devices,
    ...schedule,
    ...setOffice,
    ...report,
    ...analysis,
    ...sourceAccount,
    ...ParkEntries,
    ...PostEntries,
    ...product,
    ...training,
    ...post,
    ...support,
    ...lateReasons,
    ...AutoGeneratReport,
    ...PerformanceEvaluation,
    ...personnelEvaluation,
    ...RequestInspection,
    ...bankAccounts,
    ...productCertificate,
    ...government,
    ...unassignedRequest,
    ...sessionsTraining,
    ...GroupCer,
    ...ManufactureWhite,
    ...Complaint,
    ...NewTaskManagments,
    ...TypeCer,
    ...ZohoReports,
    ...Reimbursement,
    ...Loan,
    ...Payroll,
    ...InternalAudit,
    ...HSCode,
    ...SFDASources,
    ...fasahCertificate,
    ...documentaryRequirementsHalal,
    ...operationEngineersHalal,
    ...headOfOperations,
    ...templatesHalal,
    ...otherFormsHalal,
    ...checkListHalal,
    ...decisionCommitteeHalal,
    ...permission,
    ...activeSessions,
    ...salary,
    ...listRequiredDocuments,
    ...crmSystem,
    ...sfdaLabs,
    ...iso,
    {
      path: "/error-network",
      name: "error-network",
      component: () => import("@/views/error/Network.vue"),
      meta: {
        layout: "full"
      }
    },
    {
      path: "/error-404",
      name: "error-404",
      component: () => import("@/views/error/Error404.vue"),
      meta: {
        layout: "full"
      }
    },
    {
      path: "*",
      redirect: "error-404"
    }
  ]
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem("accessToken");
  const accessRole = localStorage.getItem("accessRole");
  const accessRoleChecked = localStorage.getItem("accessRoleChecked")
    ? decrypted(localStorage.getItem("accessRoleChecked"))
    : null;

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAccessInvalid = accessRole !== accessRoleChecked;

  if (requiresAuth && (!isLoggedIn || isAccessInvalid)) {
    if (to.name !== "login") {
      return next({ name: "login" });
    } else {
      return next(false); // Cancel navigation
    }
  }

  next();
});

router.afterEach((to, from) => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
  const DEFAULT_TITLE = "System Gulftic - Dashboard";
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

export default router;
